<script>
	// From Lucide
	import { Play } from 'lucide-svelte';

	export let iconClass = '';
</script>

<Play class={iconClass} />
